import {mapGetters} from "vuex";

export const resolveBreadcrumbItems = {
    computed: {
        ...mapGetters("user", ["userCommune"]),
        ...mapGetters("navigation", ["serviceAreas"]),
        breadcrumbItems() {
            switch (this.$route.name) {

                case "service-area": {
                    const id = parseInt(this.$route.params.serviceAreaId, 10);
                    const serviceArea = this.serviceAreas.find((item) => item.id === id);
                    return serviceArea ? ["Start", serviceArea.title] : [];
                }
                case "service": {
                    const serviceAreaId = parseInt(this.$route.params.serviceAreaId, 10);
                    const serviceId = parseInt(this.$route.params.serviceId, 10);

                    const serviceArea = this.serviceAreas.find((item) => item.id === serviceAreaId);
                    if(!serviceArea) {
                        return [];
                    }

                    const service = serviceArea.services.find((item) => item.id === serviceId);
                    if(!service) {
                        return [];
                    }

                    if(service.title === "Social Media Datenbank") {
                        return ["Start", "Neuigkeiten", service.title];
                    }

                    return ["Start", serviceArea.title, service.title];
                }
                case "sub-service": {
                    const serviceAreaId = parseInt(this.$route.params.serviceAreaId, 10);
                    const serviceId = parseInt(this.$route.params.serviceId, 10);
                    const subServiceId = parseInt(this.$route.params.subServiceId, 10);

                    const serviceArea = this.serviceAreas.find((item) => item.id === serviceAreaId);
                    if(!serviceArea) return [];

                    const service = serviceArea.services.find((item) => item.id === serviceId);
                    if(!service) return [];

                    const subService = service.subServices.find((item) => item.id === subServiceId);
                    if(!subService) return [];

                    return ["Start", serviceArea.title, service.title, subService.title];
                }
                case "commune-dashboard":
                    return ["Start", "Management Dashboard", "Kommunenübersicht"];
                case "vertragsuebersicht":
                    return ["Start", "Management Dashboard", "Verträge"];
                case "konzessionsthemen":
                    return ["Start", "Management Dashboard", "Konzessionsthemen"];
                case "elections":
                    return ["Start", "Management Dashboard", "Politische Akteure"];
                case "analytics":
                    return ["Start", "Management Dashboard", "Analytics"];
                case "strom":
                    return ["Start", "Versorgung", "Strom"];
                case "gas":
                    return ["Start", "Versorgung", "Gas"];
                case "trinkwasser":
                    return ["Start", "Versorgung", "Trinkwasser"];
                case "beleuchtung":
                    return ["Start", "Versorgung", "Straßenbeleuchtung"];
                case "waerme":
                    return ["Start", "Versorgung", "Individuelle Wärmelösungen"];
                case "about":
                    return ["Start", "Neuigkeiten", "Über die NEW"];
                case "constructions-map":
                    return ["Start", "Neuigkeiten", "Bauprojekte"];
                default: {
                    const { path } = this.$route;

                    for(const serviceArea of this.serviceAreas) {
                        if(serviceArea.link === path) {
                            return ["Start", serviceArea.title];
                        }

                        for(const service of serviceArea.services) {
                            if(service.link === path) {
                                return ["Start", serviceArea.title, service.title];
                            }

                            for(const subService of service.subServices) {
                                if(subService.link === path) {
                                    return ["Start", serviceArea.title, service.title];
                                }
                            }
                        }
                    }

                    return [];
                }
            }
        }
    },
}
